/* A reader surface, not the editing canvas: HTML serializer whitespace is not an article gap. */
.content:global(.ql-editor) {
  height: auto;
  overflow: visible;
  white-space: normal;

  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    scroll-margin-top: 80px;
  }

  & p {
    white-space: pre-line;
  }

  & pre,
  & code,
  & :global(.ql-code-block-container) {
    white-space: pre-wrap;
  }

  & img {
    display: block;
    max-width: 100%;
    height: auto;
    border-radius: var(--chakra-radii-xl);
  }

  & ul,
  & ol {
    padding-inline-start: var(--chakra-spacing-6);
  }

  & ol {
    padding-inline-start: var(--chakra-spacing-7);
  }

  & li:not([data-list]):not([data-blog-prefixed]) {
    list-style-type: inherit;
  }

  & li:not([data-list]):not([class*='ql-indent-']) {
    padding-inline-start: 0;
  }

  & ul {
    list-style-type: disc;
  }

  & ol {
    list-style-type: decimal;
  }

  & li[data-blog-prefixed]:not([class*='ql-indent-']) {
    list-style-type: none;
    padding-inline-start: 0;
  }

  & li > :global(.blog-list-marker) {
    position: absolute;
    inset-inline-end: calc(100% + var(--chakra-spacing-1));
    text-indent: 0;
    color: var(--chakra-colors-purple-fg);
  }

  /* Quill uses synthetic counters, including alpha/roman nested numbering. Keep those rules. */
  & li[data-list] {
    list-style-type: none;
  }
}

.previewImage {
  object-fit: cover;
  object-position: top center;
  height: 100%;
  width: 100%;
  position: absolute;
  filter: brightness(60%) saturate(110%);
}
